var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui-bubble",class:[("ui-bubble--" + _vm.variant), { 'ui-bubble--big': _vm.count > 9 }]},[_vm._v(" "+_vm._s(_vm.notificationsNumber)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }